export default "__VITE_ASSET__DMpwlblK__"